var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"list-box"},[_c('div',{staticClass:"content"},[_c('span',{class:_vm.boxName=='projectList'?'projectListBoxTitle':'electricityListBoxTitle'},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4d46a64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/svolt/components/list-box.vue
// module id = null
// module chunks = 